export default {
  strict: true,
  namespaced: true,
  state: {
    canvas: null,
    instance: null,
    config: {},
    max: 0,
    min: 0,
    targetKey: '',
    data: [],
  },
  getters: {
    getHeatmapPoints(state, getters, rootState, rootGetters) {
      let virtualSpots = rootGetters['area/virtualSpotAll'];

      virtualSpots = virtualSpots.filter((spot) => spot.spotState[state.targetKey] >= 0);

      virtualSpots = virtualSpots.map((spot) => ({
        x: spot.positionX,
        y: spot.positionY,
        value: spot.spotState[state.targetKey],
      }));

      return virtualSpots;
    },
  },
  mutations: {
    getCanvas(state, domElm) {
      state.canvas = domElm;
    },
    createInstance(state, heatmapElm) {
      state.instance = heatmapElm;
    },
    initConfig(state, value) {
      state.config = value;
    },
    initMinMax(state, { min, max }) {
      state.max = max;
      state.min = min;
    },
    setTargetKey(state, key) {
      state.targetKey = key;
    },
  },
  actions: {
    repaint({ state, rootState }) {
      // NOTE: heatmapjsのcanvasは動的に生成されているため、リアクティブにならないのでDOMを直接操作
      state.canvas.setAttribute('height', rootState.map.area.height);
      state.canvas.setAttribute('width', rootState.map.area.width);
      state.instance.repaint();
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/map/data/heatmap.js